import React, { useState, useEffect } from 'react';
import { Table, Button, message, Input } from 'antd';
import { EyeOutlined, CheckOutlined, CloseOutlined, EditOutlined, DeleteOutlined, SearchOutlined } from '@ant-design/icons';
import { loginRequest } from '../../authConfig';
import { useMsal } from '@azure/msal-react';
import axios from 'axios';
import ManageCommunique from './ManageCommunique';

interface CommuniqueData{
    communiqueId:string;
    headerText:string;
    imageName: string;
    description:string;
    isActive:boolean;
    createdBy:string;
    createdDate:string;
    updatedBy:string;
    updatedDate:string;
    imageCategoryName:string;
    imageSubCategoryName:string;
}

const DisplayCommunique: React.FC = () => {
  const [communiqueData, setData] = useState<CommuniqueData[]>([]);
  const [filteredData, setFilteredData] = useState<CommuniqueData[]>([]);
  const [searchText, setSearchText] = useState('');
  const [isAddCommuniqueVisible, setIsAddCommuniqueVisible] = useState(false);
  const [isEditCommuniqueVisible, setIsEditCommuniqueVisible] = useState('');
  const { instance, accounts } = useMsal();

  const API_URL = process.env.REACT_APP_API_URL;

  const fetchToken = async () => {
        const res = await instance.acquireTokenSilent({
          ...loginRequest,
          account: accounts[0]
        });
        return res.idToken;
      };
    
      useEffect(() => {
        fetchToken();
      }, []);

      useEffect(() => {
        getCommuniqueData();
      }, [isAddCommuniqueVisible]);

      const userId = localStorage.getItem("UserId");

      const getCommuniqueData = async () => {
        try {
          const token = await fetchToken();
          const response = await axios.get(`${process.env.REACT_APP_API_URL}/api/COECommunique/GetCOECommunique/`, {
            headers: {
              Authorization: `Bearer ${token}`,
              'Content-Type': 'application/json',
            }
          });
          setData(response.data);
          setFilteredData(response.data);

        } catch (error) {
          console.error("Error fetching communique details", error);
        }
      };

      const handleSearch = (value: string) => {
        setSearchText(value);
        const filtered = communiqueData.filter(item =>
          (item.imageCategoryName?.toLowerCase() || '').includes(value.toLowerCase()) ||
          (item.imageSubCategoryName?.toLowerCase() || '').includes(value.toLowerCase()) ||
          (item.headerText?.toLowerCase() || '').includes(value.toLowerCase()) ||
          (item.description?.toLowerCase() || '').includes(value.toLowerCase())
        );
        setFilteredData(filtered);
      };

      const handleDeleteCommuniqueData = async (communiqueId: string) => {
        const confirmed = window.confirm('Are you sure you want to delete this item?');
        if(confirmed){
          try {
            const token = await fetchToken();
            const response = await axios.put(`${process.env.REACT_APP_API_URL}/api/COECommunique/DeleteCOECommunique`, 
              null,
            {
              params:{
                communique_id: communiqueId,
                user_id: userId
              },
              headers: {
                Authorization: `Bearer ${token}`
              }
            });
            message.success('Communique data deleted successfully');
            getCommuniqueData();
          } catch (error) {
            console.error("Error deleting details", error);
          }
        }
      };

      const columns = [
          {
            title: 'Category Name',
            dataIndex: 'imageCategoryName',
            key: 'imageCategoryName',
            sorter: (a: CommuniqueData, b: CommuniqueData) => a.imageCategoryName.localeCompare(b.imageCategoryName),
          },
          {
            title: 'Sub Category Name',
            dataIndex: 'imageSubCategoryName',
            key: 'imageSubCategoryName',
            sorter: (a: CommuniqueData, b: CommuniqueData) => a.imageSubCategoryName.localeCompare(b.imageSubCategoryName),
          },
          {
            title: 'Header Text',
            dataIndex: 'headerText',
            key: 'headerText',
            sorter: (a: CommuniqueData, b: CommuniqueData) => a.headerText.localeCompare(b.headerText),
          },
          // {
          //   title: 'Status',
          //   dataIndex: 'isActive',
          //   key: 'isActive',
          //   render: (text: boolean) => (text?"Active":"InActive"),
          // },
          {
            title: 'Actions',
            dataIndex: 'actions',
            render: (_: any, record: CommuniqueData) => (
              <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button danger icon={<DeleteOutlined />} onClick={() => handleDeleteCommuniqueData(record.communiqueId)}>Delete</Button>
              </div>
            ),
          },
        ];

  return (
    <div>
      <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <Button type="primary" onClick={() => setIsAddCommuniqueVisible(false)} style={{ marginRight: 8 }}>
            View Communique
          </Button>
          <Button type="primary" onClick={() => {
            setIsAddCommuniqueVisible(true);
            setIsEditCommuniqueVisible('');
          }} style={{ marginRight: 8 }}>
            Add Communique
          </Button>
        </div>
        <div>
          <Input
            placeholder="Search communiques..."
            prefix={<SearchOutlined />}
            value={searchText}
            onChange={(e) => handleSearch(e.target.value)}
            style={{ width: 300 }}
            allowClear
          />
        </div>
      </div>
      {isAddCommuniqueVisible ? (<ManageCommunique />) : (
        <Table 
          dataSource={filteredData} 
          columns={columns} 
          rowKey="communiqueId" 
          pagination={{
            showSizeChanger: true,
            showQuickJumper: false,
            showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
            pageSizeOptions: ['5', '10', '20', '50', '100'],
            defaultPageSize: 50,
            showLessItems: true,
          }}
        />
      )}
    </div>
  );
};

export default DisplayCommunique;